/** Glow theme constants. Colors that JS/SVG needs directly (Recharts,
 * Gauge, etc.). Tailwind utilities cover everything in className. */
export const THEME = {
  brand: {
    start: "#a78bfa",
    end: "#ec4899",
  },
  gold: "#fbbf24",
  silver: "#cbd5e1",
  bronze: "#d97706",
  text: {
    primary: "#f3f4f6",
    muted: "#94a3b8",
  },
  grid: "rgba(255,255,255,0.08)",
} as const;

/** Medal color per rank (1..3). Falls back to brand for 4+. */
export function medalColor(rank: number): string {
  if (rank === 1) return THEME.gold;
  if (rank === 2) return THEME.silver;
  if (rank === 3) return THEME.bronze;
  return THEME.brand.start;
}

/** Emoji-free medal label. */
export function medalLabel(rank: number): string {
  if (rank === 1) return "1º";
  if (rank === 2) return "2º";
  if (rank === 3) return "3º";
  return `#${rank}`;
}
